import {  fetchAllActivityByEntityId, fetchAllActivity } from '../../services/policyActivityServices';
import { START_LOADING, STOP_LOADING } from './actionTypes';

export const fetchPolicyAllActivity = (id,page=0,size=5) => async (dispatch, getState) => {
    try {
      
      const token = getState().auth.token ||sessionStorage.getItem("token");
      const response = await fetchAllActivityByEntityId(id,page,size,token);
      dispatch({ type: 'SET_ALL_ACTIVITY_SUCCESS', payload: response });
     
    } catch (error) {
      dispatch({ type: 'SET_ALL_ACTIVITY_FAILURE', payload: error.message || 'All activity service failed. Please try again.' });
    }
  };

  export const getAllActivity = (page=0,size=5) => async (dispatch, getState) => {
    try {
      dispatch({ type: START_LOADING, service: 'START_LOADING' });
      const token = getState().auth.token ||sessionStorage.getItem("token");
      const response = await fetchAllActivity(page,size,token);
      dispatch({ type: 'GET_ALL_ACTIVITY_SUCCESS', payload: response });
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    } catch (error) {
      dispatch({ type: 'SET_ALL_ACTIVITY_FAILURE', payload: error.message || 'All activity service failed. Please try again.' });
    }
  };